import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Select from 'react-select';

import {
	setFilename,
	storeBlob,
	loadFile,
    fileContainsHeaders,
	setHeadersAndRows,
	updateSelectedHeaders,
	setAxisLabel
} from '../redux/file-actions';

import FileControl from './FileControl';
import CheckboxControl from './CheckboxControl';
import FormulaControl from './FormulaControl';

class Controls extends Component {
	getHeaderOptions(headers) {
		return headers.map(h => { return { value: h.Header, label: h.Header }; } )
	}
	render() {
		return (
			<section className="controls">
				<div className="row">
					<div className="three columns control">
						<FileControl
							fileId={this.props.fileId}
							filename={this.props.filename}
							isLoaded={this.props.isLoaded}
							setFilename={(fileId, value, dispatch) => {
								dispatch(setFilename(fileId, value));
							}}
							storeBlob={(fileId, value, dispatch) => {
								dispatch(storeBlob(fileId, value));
							}}
							loadFile={(fileId, value, dispatch) => {
								dispatch(loadFile(fileId));
							}} />
					</div>
					<div className="three columns">
						<div className="control">
							<CheckboxControl 
								fileId={this.props.fileId}
								id={"headers-"+this.props.fileId}
								text="Headers?"
								isChecked={this.props.hasHeaders}
								checkedChanged={(fileId, value) => {
									// console.log("Trigger:", new Date().getTime());
									this.props.dispatch(fileContainsHeaders(fileId, value));
									this.props.dispatch(setHeadersAndRows(fileId));
								}}
							/>
						</div>
						<div className="control">
							<label htmlFor={this.props.fileId+"-axisLabel"}>Axis Label</label>
							<input id={this.props.fileId+"-axisLabel"} type="text" value={this.props.axisLabel} onChange={(e) => {
								this.props.dispatch(setAxisLabel(this.props.fileId, e.target.value))}}/>
						</div>
					</div>
					<div className="six columns">
						<div className="control">
							<label>Axis Variables</label>
							<Select
								name="headers"
								value={this.props.headerSelection}
								options={this.props.headers && this.props.headers.map((h, i) => { 
									return { value: i, label: h.Header }; })}
								multi={true}
								onChange={(v) => {
									let value = "";
									if (v.length !== undefined) {
										value = v.map((vi) => vi.value);
									} else if (v != null) {
										value = v.value;
									}
									this.props.dispatch(updateSelectedHeaders(this.props.fileId, value))
								}}
							/>
						</div>
						<FormulaControl
							fileId={this.props.fileId}
							dispatch={this.props.dispatch}
							headers={this.props.headers}
							headerSelection={this.props.headerSelection}
							exampleValues={this.props.firstRow}
							formula={this.props.formula}
						/>
					</div>
				</div>
			</section>
		);
	}
};

Controls.propTypes = {
	fileId: PropTypes.string.isRequired,
	filename: PropTypes.string,
	isLoaded: PropTypes.bool,
	hasHeaders: PropTypes.bool,
	headers: PropTypes.array,
	headerSelection: PropTypes.array,
	dispatch: PropTypes.func,
	formula: PropTypes.string,
	firstRow: PropTypes.string,
	axisLabel: PropTypes.string,
}

export default Controls;


// WEBPACK FOOTER //
// ./src/components/Controls.js